module.exports = __webpack_public_path__ + "static/media/mw.59519962.svg";